export const GOBIERTO_BUDGETS = {
  LOADED: "chart-loaded"
}

export const GOBIERTO_DASHBOARDS = {
  CREATE: "create-dashboard-maker",
  LOAD: "load-dashboard-viewer",
  LOADED: "dashboard-viewer-loaded",
  SELECTED: "dashboard-viewer-selected"
}